import FiltersDataPresenter from '@/study-search/presenters/FiltersDataPresenter';
import { Continent } from './Continent';
import { FilterOptionInformation } from '@studyportals/search-filters';

class ContinentFilterOptionInformationFactory {
	private filtersDataPresenter = FiltersDataPresenter;
	private continentFilterOptionInformation: FilterOptionInformation[] = [];

	public getContinentFilterInformation(): FilterOptionInformation[] {
		const continents = this.filtersDataPresenter.getContinents();
		this.continentFilterOptionInformation = this.generateContinentFilterOptionInformation(continents);

		return this.continentFilterOptionInformation;
	}

	public getContinentFilterOptionValues(): string[] {
		return this.continentFilterOptionInformation.map((_) => _.optionValue);
	}

	private generateContinentFilterOptionInformation(continents: Continent[]): FilterOptionInformation[] {
		return continents.map((_) => new FilterOptionInformation(_.name, _.identity, _.name.toLowerCase().replace(' ', '-'), _.name));
	}
}

export default new ContinentFilterOptionInformationFactory();
